// extracted by mini-css-extract-plugin
export default {"wrapper":"viewer-chat_wrapper__Us5Jx","header":"viewer-chat_header__zg4K7","rounded":"viewer-chat_rounded__o7xBb"};